import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../components/MetaPixel';
const fadeUp = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
export function ThankYouPage() {
  useEffect(() => {
    trackEvent('Purchase', {
      content_name: 'El Arte de Crear Espacios Sagrados',
      content_category: 'eBook',
      value: 7.99,
      currency: 'USD'
    });
  }, []);
  return <div className="min-h-screen bg-cream-light selection:bg-gold-main/30 selection:text-brown-dark" data-id="element-311">
      {/* 1. HERO SECTION */}
      <section className="relative bg-cream-light pt-10 pb-14 md:pt-16 md:pb-20" data-id="element-312">
        <div className="absolute inset-0 opacity-20 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(#C4A265 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} data-id="element-313" />
        <div className="max-w-3xl mx-auto px-6 relative z-10 text-center space-y-6" data-id="element-314">
          <motion.div {...fadeUp} data-id="element-315">
            <img src="https://cdn.magicpatterns.com/uploads/iwry5jWpKzBng5LRuRN5Xg/HERO_SECTION.webp" alt="El Arte de Crear Espacios Sagrados" className="w-64 md:w-80 mx-auto drop-shadow-xl mb-6" data-id="element-316" />
          </motion.div>

          <motion.div {...fadeUp} transition={{
          delay: 0.1
        }} data-id="element-317">
            <p className="text-gold-main text-lg font-lora" data-id="element-318">💛</p>
            <h1 className="text-3xl md:text-5xl font-playfair font-bold text-brown-dark leading-tight" data-id="element-319">
              Gracias por confiar en este proceso
            </h1>
          </motion.div>

          <motion.div {...fadeUp} transition={{
          delay: 0.2
        }} className="space-y-3" data-id="element-320">
            <p className="font-lora text-lg text-brown-dark font-medium" data-id="element-321">
              Tu compra fue confirmada con éxito.
            </p>
            <p className="font-lora text-lg text-brown-light" data-id="element-322">
              Bienvenida a{' '}
              <span className="italic text-gold-dark" data-id="element-323">
                El Arte de Crear Espacios Sagrados.
              </span>
            </p>
          </motion.div>

          <motion.div {...fadeUp} transition={{
          delay: 0.3
        }} className="space-y-3" data-id="element-324">
            <p className="font-lora text-brown-light" data-id="element-325">
              Estás a punto de recibir una guía profunda y amorosa que te
              acompañará a:
            </p>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 font-lora text-brown-dark" data-id="element-326">
              <span data-id="element-327">✨ cerrar ciclos</span>
              <span data-id="element-328">✨ honrar momentos importantes</span>
              <span data-id="element-329">✨ sanar procesos emocionales</span>
              <span data-id="element-330">✨ crear rituales con sentido</span>
            </div>
          </motion.div>

          <motion.div {...fadeUp} transition={{
          delay: 0.4
        }} className="pt-4 space-y-4" data-id="element-331">
            <div className="bg-cream-dark p-6 md:p-8 rounded-sm border border-gold-main/20 space-y-3" data-id="element-332">
              <p className="font-lora text-lg font-medium text-brown-dark" data-id="element-333">
                📥 Accede ahora a tu ebook
              </p>
              <p className="font-lora text-brown-light" data-id="element-334">
                Tu ebook y tus bonos ya están disponibles. Revisa tu correo
                electrónico para acceder a tu contenido o ingresa directamente
                desde el siguiente botón.
              </p>
              <a href="https://pay.hotmart.com/R104866725J" target="_blank" rel="noopener noreferrer" className="inline-block bg-gold-main text-white font-lora font-semibold text-lg py-4 px-10 rounded-sm shadow-md hover:shadow-lg transition-shadow mt-2" data-id="element-335">
                Acceder a mi ebook ahora
              </a>
              <p className="font-lora text-sm text-brown-light/70 italic" data-id="element-336">
                Si no ves el correo, revisa tu carpeta de spam o promociones.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 2. MENSAJE DE PAULA */}
      <section className="bg-cream-dark py-14 md:py-20" data-id="element-337">
        <div className="max-w-3xl mx-auto px-6" data-id="element-338">
          <motion.div {...fadeUp} className="space-y-5" data-id="element-339">
            <h2 className="text-2xl md:text-4xl font-playfair font-bold text-brown-dark text-center" data-id="element-340">
              Un mensaje especial para ti
            </h2>
            <div className="font-lora text-lg text-brown-light leading-relaxed space-y-4" data-id="element-341">
              <p data-id="element-342">
                No sabes lo feliz que me siento de poder compartir este ebook
                contigo.
              </p>
              <p data-id="element-343">
                Durante mucho tiempo trabajé en silencio creando este contenido
                con dedicación, amor y respeto por los procesos emocionales de
                las personas.
              </p>
              <p data-id="element-344">
                Este libro reúne muchos de los rituales que he creado durante
                años acompañando a personas en momentos importantes de sus
                vidas.
              </p>
              <p className="font-medium text-brown-dark" data-id="element-345">
                Aquí encontrarás rituales para hacer:
              </p>
              <div className="flex flex-wrap gap-x-6 gap-y-1" data-id="element-346">
                <span data-id="element-347">✨ de manera individual</span>
                <span data-id="element-348">✨ en pareja</span>
                <span data-id="element-349">✨ en grupo</span>
              </div>
              <p className="italic text-brown-dark border-l-2 border-gold-main pl-4 mt-2" data-id="element-350">
                Y también encontrarás ceremonias completas que hoy realizo con
                mi propio sello.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 3. QUÉ VAS A ENCONTRAR */}
      <section className="bg-cream-light py-14 md:py-20" data-id="element-351">
        <div className="max-w-3xl mx-auto px-6" data-id="element-352">
          <motion.div {...fadeUp} className="space-y-6" data-id="element-353">
            <h2 className="text-2xl md:text-4xl font-playfair font-bold text-brown-dark text-center" data-id="element-354">
              Dentro del ebook descubrirás
            </h2>

            <div className="font-lora text-lg text-brown-light space-y-5" data-id="element-355">
              <p className="font-medium text-brown-dark" data-id="element-356">
                Una guía teórica y práctica para crear rituales como:
              </p>
              <ul className="space-y-2 pl-1" data-id="element-357">
                <li data-id="element-358">🌿 Ritual de cumpleaños</li>
                <li data-id="element-359">🌿 Ritual de cierre de ciclos</li>
                <li data-id="element-360">🌿 Ritual de fin de año y mapa de sueños</li>
                <li data-id="element-361">🌿 Ritual para atraer abundancia</li>
                <li data-id="element-362">🌿 Ritual para desarrollar tu intuición</li>
                <li data-id="element-363">🌿 Ritual de amor propio</li>
              </ul>

              <p className="font-medium text-brown-dark pt-2" data-id="element-364">
                Además encontrarás guías para crear ceremonias como:
              </p>
              <ul className="space-y-2 pl-1" data-id="element-365">
                <li data-id="element-366">💫 Ceremonias de unión</li>
                <li data-id="element-367">💫 Bienvenida al mundo</li>
                <li data-id="element-368">💫 Bendición de nombre</li>
              </ul>

              <div className="bg-cream-dark p-6 rounded-sm border border-gold-main/20 mt-4" data-id="element-369">
                <p className="font-medium text-brown-dark mb-2" data-id="element-370">
                  Y uno de los rituales más especiales del libro:
                </p>
                <p className="text-xl" data-id="element-371">
                  🕊{' '}
                  <span className="font-playfair font-semibold text-brown-dark" data-id="element-372">
                    Ritual para ayudarte a atravesar un duelo
                  </span>
                </p>
                <p className="text-brown-light mt-2 italic" data-id="element-373">
                  Un proceso creado con mucho cuidado para acompañar momentos
                  difíciles.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 4. CÓMO USAR ESTE EBOOK */}
      <section className="bg-cream-dark py-14 md:py-20" data-id="element-374">
        <div className="max-w-3xl mx-auto px-6" data-id="element-375">
          <motion.div {...fadeUp} className="space-y-5" data-id="element-376">
            <h2 className="text-2xl md:text-4xl font-playfair font-bold text-brown-dark text-center" data-id="element-377">
              Algo muy importante que quiero que sepas
            </h2>
            <div className="font-lora text-lg text-brown-light leading-relaxed space-y-4" data-id="element-378">
              <p className="font-medium text-brown-dark text-center text-xl" data-id="element-379">
                No tienes que leer este libro en orden.
              </p>
              <p data-id="element-380">
                Son más de 200 páginas llenas de contenido profundo, por lo que
                mi recomendación es simple:
              </p>
              <div className="bg-cream-light p-6 rounded-sm space-y-2" data-id="element-381">
                <p data-id="element-382">✨ Mira el índice</p>
                <p data-id="element-383">✨ Encuentra el ritual que más resuene contigo</p>
                <p data-id="element-384">✨ Ve directamente a esa página</p>
              </div>
              <p className="italic text-brown-dark" data-id="element-385">
                Este libro está diseñado para acompañarte según lo que estés
                viviendo en este momento de tu vida.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 5. RECORDATORIO IMPORTANTE */}
      <section className="bg-cream-light py-14 md:py-20" data-id="element-386">
        <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-387">
          <motion.div {...fadeUp} className="space-y-5" data-id="element-388">
            <p className="font-lora text-brown-light text-lg" data-id="element-389">
              Recuerda algo que siempre digo cuando acompaño ceremonias:
            </p>
            <blockquote className="text-2xl md:text-3xl font-playfair font-bold text-brown-dark leading-snug max-w-2xl mx-auto" data-id="element-390">
              Un ritual no es poderoso por los objetos que usas. Es poderoso por
              la intención, la presencia y la profundidad con la que lo
              realizas.
            </blockquote>
            <p className="font-lora text-gold-dark italic text-lg" data-id="element-391">
              Este libro te ayudará a llegar a esa raíz.
            </p>
          </motion.div>
        </div>
      </section>

      {/* 6. TUS BONOS INCLUIDOS */}
      <section className="bg-cream-dark py-14 md:py-20" data-id="element-392">
        <div className="max-w-3xl mx-auto px-6" data-id="element-393">
          <motion.div {...fadeUp} className="space-y-6" data-id="element-394">
            <h2 className="text-2xl md:text-4xl font-playfair font-bold text-brown-dark text-center" data-id="element-395">
              Además del ebook también recibiste acceso a:
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-396">
              <div className="bg-cream-light p-6 rounded-sm border border-gold-main/20 text-center space-y-2" data-id="element-397">
                <p className="text-2xl" data-id="element-398">✨</p>
                <p className="font-playfair font-semibold text-brown-dark" data-id="element-399">
                  Plantillas de Gratitud
                </p>
              </div>
              <div className="bg-cream-light p-6 rounded-sm border border-gold-main/20 text-center space-y-2" data-id="element-400">
                <p className="text-2xl" data-id="element-401">✨</p>
                <p className="font-playfair font-semibold text-brown-dark" data-id="element-402">
                  Plantillas de Cartas Terapéuticas
                </p>
              </div>
              <div className="bg-cream-light p-6 rounded-sm border border-gold-main/20 text-center space-y-2" data-id="element-403">
                <p className="text-2xl" data-id="element-404">✨</p>
                <p className="font-playfair font-semibold text-brown-dark" data-id="element-405">
                  Checklist 21 días — Sanando tu Niña Interior
                </p>
              </div>
            </div>
            <p className="font-lora text-brown-light text-center italic" data-id="element-406">
              Todo disponible junto con tu ebook.
            </p>
          </motion.div>
        </div>
      </section>

      {/* 7. SECCIÓN COMUNIDAD */}
      <section className="bg-cream-light py-14 md:py-20" data-id="element-407">
        <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-408">
          <motion.div {...fadeUp} className="space-y-5" data-id="element-409">
            <h2 className="text-2xl md:text-4xl font-playfair font-bold text-brown-dark" data-id="element-410">
              Si este libro resonó contigo, te invito a seguir este camino
              conmigo.
            </h2>
            <p className="font-lora text-lg text-brown-light" data-id="element-411">
              Sígueme en Instagram (
              <span className="font-semibold text-gold-dark" data-id="element-412">
                @ceremoniasimbolicas.paula
              </span>
              ) para más contenido sobre:
            </p>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 font-lora text-brown-dark" data-id="element-413">
              <span data-id="element-414">✨ rituales</span>
              <span data-id="element-415">✨ ceremonias</span>
              <span data-id="element-416">✨ procesos emocionales</span>
              <span data-id="element-417">✨ espiritualidad consciente</span>
            </div>
            <a href="https://www.instagram.com/ceremoniasimbolicas.paula" target="_blank" rel="noopener noreferrer" className="inline-block bg-gold-main text-white font-lora font-semibold text-lg py-4 px-10 rounded-sm shadow-md hover:shadow-lg transition-shadow mt-2" data-id="element-418">
              Seguir a Paula Giraldo
            </a>
          </motion.div>
        </div>
      </section>

      {/* 8. FOOTER */}
      <footer className="bg-brown-dark text-cream-light py-10" data-id="element-419">
        <div className="max-w-3xl mx-auto px-6 text-center space-y-4" data-id="element-420">
          <p className="font-lora text-cream-dark/80" data-id="element-421">
            Si tienes cualquier problema con tu acceso puedes escribirnos a:
          </p>
          <a href="https://wa.me/573150936091" target="_blank" rel="noopener noreferrer" className="inline-block font-lora font-semibold text-gold-main text-lg hover:text-gold-light transition-colors" data-id="element-422">
            +57 315 0936091
          </a>
          <div className="pt-4 border-t border-cream-dark/20" data-id="element-423">
            <p className="font-lora text-cream-dark/70" data-id="element-424">
              Gracias por confiar en este proceso.
            </p>
            <p className="font-playfair font-semibold text-gold-main mt-1" data-id="element-425">
              Con amor, Paula Giraldo
            </p>
          </div>
        </div>
      </footer>
    </div>;
}